import React from 'react';
import { Link } from 'react-router-dom';
import { BootstrapIcon } from './BootstrapIcon';


type attributes = {
    title : string,
    backPage :string,
    children : any,
}

export const ClickableDiv = (divProps:any) => {
    if(divProps.backPage == ''){
        return <div className={divProps.cssClasses}>
            {divProps.children}
        </div>
    } else {
        return <div>
            <Link to={divProps.backPage}  className={'link-simple ' + divProps.cssClasses}>
                {divProps.children}
            </Link>
        </div>
    }
}

export const PageHeader = (props: attributes) => {
    return (
        <div className="d-flex flex-row justify-content-start align-items-center gap-3 mb-3">
               {props.backPage != '' && <ClickableDiv cssClasses='' backPage={props.backPage}>
                   <BootstrapIcon bootStrapIconName='arrow-left-circle' size={24} cssClasses='' />
               </ClickableDiv>}
               <ClickableDiv cssClasses='flex-grow-1' backPage={props.backPage}>
                   <h5>{props.title}</h5>
                </ClickableDiv> 
               <div>
                   {props.children}
               </div>
        </div>
    );

}